import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import {
  AllCommunityModule,
  ModuleRegistry,
  provideGlobalGridOptions,
} from 'ag-grid-community';

// Depuis la v33, les fonctionnalités de la grille doivent être enregistrées explicitement.
// Exécuté au chargement du module (importé par CoreModule), donc avant la création de toute grille.
ModuleRegistry.registerModules([AllCommunityModule]);

// Conserve les thèmes v32 (CSS ag-theme-alpine importés dans src/themes/*.scss) au lieu de la Theming API.
provideGlobalGridOptions({ theme: 'legacy' });

@NgModule({
  declarations: [],
  imports: [AgGridModule],
  exports: [AgGridModule],
})
export class GridModule {}
